export default __webpack_public_path__ + "static/media/phone.dcef80d1.png";